interface ServiceCardProps {
  className?: string;
  children?: React.ReactNode;
}

export function ServiceCard({ className, children }: ServiceCardProps) {
  return (
    <div
      className={`flex flex-col items-start justify-self-stretch p-4 md:p-5 ${className || ''}`}
      style={{
        borderRadius: '12px',
        border: '1px solid #1C2535',
        background: 'rgba(15, 20, 35, 0.80)',
        minHeight: '180px',
      }}
    >
      {children}
    </div>
  );
}
